import { FC, useState } from 'react';

import { useModalContext } from '../../hooks/contexts/modal.context';
import { createWaitlistEntry } from '../../services/waitlistService';
import { cleanPhoneNumber } from '../../utils/phoneUtils';
import { WaitlistForm, WaitlistFormData } from './WaitlistForm';
import { WaitlistSuccess } from './WaitlistSuccess';

interface WaitlistModalProps {
  eventId : number;
  userId ?: number;
}

type Step = 'form' | 'success';

const WaitlistModal: FC<WaitlistModalProps> = ({ eventId, userId }) => {
  const [step, setStep] = useState<Step>('form');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { toggleModal } = useModalContext();

  const handleSubmit = async (values : WaitlistFormData) => {
    setIsSubmitting(true);
    setError(null);
    try {
      const phone = cleanPhoneNumber(`+${values.ddi}${values.whatsapp}`);
      await createWaitlistEntry({
        username : values.fullName,
        email : values.email,
        phone,
        event_id : eventId,
        ...(userId ? { user_id : userId } : {}),
      });
      setStep('success');
    } catch (err : unknown) {
      const e = err as { code ?: string };
      if (e.code === 'DUPLICATE') {
        setError('Você já está cadastrado na lista de espera deste evento.');
      } else if (e.code === 'BAD_REQUEST') {
        setError('Dados inválidos. Verifique os campos e tente novamente.');
      } else {
        setError('Ocorreu um erro. Tente novamente.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    toggleModal({ open : false });
    setTimeout(() => {
      setStep('form');
      setError(null);
    }, 300);
  };

  if (step === 'success') {
    return <WaitlistSuccess onClose={handleClose} />;
  }

  return (
    <WaitlistForm
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      error={error}
    />
  );
};

export default WaitlistModal;
